// extracted by mini-css-extract-plugin
export default {"figure":"BodyDogImgLeft_figure__hKDfL","caption":"BodyDogImgLeft_caption__ECgJv"};